import React, { useState, useEffect } from "react";
import { FaChevronUp } from "react-icons/fa";



const ScrollTop = () => {
  const [visible, setVisible] = useState(false);

  // Show or hide the button based on scroll position
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to the top when the button is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {visible && (
        <div style={styles.container} onClick={scrollToTop}>
          <FaChevronUp style={styles.icon} />
        </div>
      )}
    </>
  );
};

const styles = {
  container: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: "#b92632",
    border: "3px solid #ffffff", // ✅ added width + style + color
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
  },
  icon: {
    color: "white",
    fontSize: "20px",
  },
};


export default ScrollTop;
